import React, { Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import validate from "./validate";
import Typography from "@material-ui/core/Typography";
import renderField from "./renderField";
import renderDropdown from "./renderDropdown";
import RenderSpeciesOption from "./renderSpeciesOptions";
import RenderKillOptions from "./renderKillOptions";
import RenderSexOptions from "./renderSexOptions";
import RenderAgeOptions from "./renderAgeOptions";
import renderCheckbox from "./renderCheckBoxField"

const required = value => (value ? undefined : "Required");



const WizardFormThirdPage = props => {
  const { handleSubmit, pristine, previousPage, submitting } = props;
  return (
    <Fragment>
      <Typography variant="title" color="inherit">
        Kill Information
      </Typography>
      <hr />
      <form onSubmit={handleSubmit}>
        <label>Date of Kill</label>
        <Field
          name="killDate"
          type="date"
          component={renderField}
          validate={required}
        />

        <Field
          name="species"
          label="Species"
          optionsData={<RenderSpeciesOption />}
          component={renderDropdown}
        />

        <Field
          name="killType"
          label="Type of Kill"
          optionsData={<RenderKillOptions />}
          component={renderDropdown}
          validate={required}
        />

        <Field
          name="sex"
          label="Sex"
          optionsData={<RenderSexOptions />}
          component={renderDropdown}
        />

        <Field
          name="age"
          label="Age"
          optionsData={<RenderAgeOptions />}
          component={renderDropdown}
        />

        <div style={{display:"flex", flexDirection:"row"}}>
        <Field
            name="earNotch"
            id="earNotch"
            component={renderCheckbox}
            type="checkbox"
            label="Ear Notch"
          />
          <Field
            name="donated"
            id="donated"
            component={renderCheckbox}
            type="checkbox"
            label="Donated"
          />
        </div>

        <Field
          name="comment"
          type="text"
          component={renderField}
          label="Comments"
          multiline={true}
        />

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={previousPage}
          >
            Previous
          </button>

          <button
            className="btn btn-success"
            type="submit"
            disabled={pristine || submitting}
          >
            Next
          </button>
        </div>
      </form>
    </Fragment>
  );
};
export default reduxForm({
  form: "wizard", //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
})(WizardFormThirdPage);



// WEBPACK FOOTER //
// ./src/components/wizardSection/WizardFormThirdPage.jsx